import useTrades from "../../../../../core/hooks/main/orders/useTrades";
import { CFlex, CMargin, DText, Flex, Padding, Row } from "../../../../../styles/CommonStyles";
import { TradeTypeBadge } from "../../../../../styles/main/orders";
import CoinMarket from "../../../../common/common/CoinMarket";
import Operation from "../../../../common/utils/Operation";
import UserLink from "../../../../common/utils/UserLink";
import DateTime from "../../../../common/utils/DateTime";
import { RespIndex } from "../../../../../styles/main/MainCommonStyles";
import RTableLayout from "../../../../responsive/layout/RTableLayout";
import CoinRow from "../../../../common/common/CoinRow";
import { useNavigate } from "react-router-dom";

const RCardsTable = ({ data }) => {

    const { data: cards } = data;
    const navigate = useNavigate()


    return (
        <RTableLayout data={data}>
            {cards?.data?.map((card, idx) => (

                <Row
                    key={card._id}
                    index={idx}
                    cs="100%"
                >

                    {/* Header */}

                    <Flex fw justify="space-between">
                        <Padding padding="8px 12px">
                            <CoinRow
                                coin={{ id: card.meta?.currency?.toLowerCase() }}
                            />
                        </Padding>

                        <Operation
                            onDetailsClicked={() => navigate(`/reports/cards/card/${card._id}`)}
                            hasDetails
                        />
                    </Flex>

                    <CMargin margin="8px" />

                    {/* User + Status */}

                    <Flex fw justify="space-between">

                        <UserLink
                            _id={card.userId}
                            name={card.user?.email}
                        />

                        <TradeTypeBadge
                            color={
                                card.status === "success"
                                    ? "success"
                                    : card.status === "pending"
                                        ? "warning"
                                        : "danger"
                            }
                        >
                            {card.status}
                        </TradeTypeBadge>

                    </Flex>

                    <CMargin margin="10px" />

                    {/* Details */}

                    <Flex fw justify="space-between">
                        <DText main fontSize="s">
                            Last 4
                        </DText>

                        <DText main fontSize="s">
                            **** {card.lastFour}
                        </DText>
                    </Flex>

                    <Flex fw justify="space-between">
                        <DText main fontSize="s">
                            Type
                        </DText>

                        <TradeTypeBadge color="primary">
                            {card.type}
                        </TradeTypeBadge>
                    </Flex>

                    <Flex fw justify="space-between">
                        <DText main fontSize="s">
                            Provider
                        </DText>

                        <DText main fontSize="s">
                            {card.provider}
                        </DText>
                    </Flex>

                    <Flex fw justify="space-between">
                        <DText main fontSize="s">
                            Currency
                        </DText>

                        <DText main fontSize="s">
                            {card.meta?.currency}
                        </DText>
                    </Flex>

                    <Flex fw justify="space-between">
                        <DText main fontSize="s">
                            Date
                        </DText>

                        <DateTime dt={card.createdAt} />
                    </Flex>

                    <RespIndex>
                        {idx + 1}
                    </RespIndex>

                </Row>
            ))}
        </RTableLayout>
    );
};

export default RCardsTable;